import { render } from "./club-regular-event-add.vue?vue&type=template&id=2ea05676"
import script from "./club-regular-event-add.vue?vue&type=script&lang=js"
export * from "./club-regular-event-add.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__